<template>
  <div class="diagnosis_lightbox">
    <div class="dLinghtbox_show">
      <section>
        <p>{{ title }}</p>
        <img
          class="img-responsive"
          :src="loadImg"
          :alt="title"
        />
      </section>
      <ul class="dia_timeBar timelineBar list-unstyled">
        <step
          :description="description.desc1"
          step="one"
          :styleClass="{
            styleMain: {step: true, success: true, hidden: isGreen}
          }">
        </step>
        <step
          componentName="DiagnosisSensorStep"
          :bikeErrorCode="bikeErrorCode.ErrorCodeBike"
          :description="description.desc2"
          :status="description.status"
          :strSlice="strSlice(description.desc2)"
          step="two"
          :second="second"
          :time="time"
          :styleClass="{
            styleMain: {step: true, 'step-bar-none-finish': isHide, error: isError, active: isActive, success: isSuccess},
            styleStatus: {error: isError, success: isSuccess}
          }">
        </step>
        <step
          :description="description.desc3"
          step="three"
          :styleClass="{
            styleMain: {step: true, 'hidden': isHide}
          }">
        </step>
      </ul>
    </div>
    <div class="dLinghtbox_control">
      <Operator
        :btnText="{up: '', down: btnCancel, power: btnStep}"
        :isHidePower="isHidePower"
        @keyDownEvent="funcHandleDown('cancel')"
        @keyPowerEvent="funcHandlePower(btnStep)"/>
    </div>
  </div>
</template>
<script>
import Operator from './Operator';
import Step from './Step';

export default {
  name: 'DiagnosisSensorStep',
  props: [
    'modalOpen',
    'title',
    'itemId',
    'btn',
    'bikeVal',
    'content',
    'seconds',
    'bikeStatus',
    'bikeErrorCode'
  ],
  components: {
    Operator,
    Step
  },
  data () {
    return {
      description: {
        desc1: '',
        desc2: this.content.step1,
        desc3: this.content.step2,
        status: ''
      },
      btnStep: this.btn,
      btnCancel: this.$t('diagnosis.btnStep.cancel'),
      isGreen: true,
      isError: false,
      isActive: true,
      isSuccess: false,
      isHide: false,
      isHidePower: false,
      btnNext: {
        step1: 'start',
        step2: 'next',
        step3: 'countDown',
        step4: 'result',
        step5: 'finish'
      },
      diagnosisName: 'sensor',
      count: 0,
      second: 20,
      time: false
    };
  },
  mounted () {
    this.$bus.$on('powerClick', () => {
      // 暫時這樣設定，當power是disabled防止用戶在bike console操作
      if (this.isHidePower) return;
      this.funcHandlePower(this.btnStep);
    });
  },
  beforeDestroy () {
    this.$bus.$off('powerClick');
  },
  watch: {
    content: {
      handler: function () {
        this.funcStepDefault();
      },
      immediate: true
    },
    seconds (val) {
      this.second = 20 - val;
    },
    modalOpen (val) {
      // 如果關閉modal
      this.btnStep = this.$t('diagnosis.btnStep.start');
      this.btnCancel = this.$t('diagnosis.btnStep.cancel');
      if (!val) {
        this.funcStepDefault();
      }
    },
    count (val, old) {
      /**
       * step1: start,0
       * step2: next,1
       * step3: countDown,2
       * step4: result,3
       * step5: finish4
       */
      switch (this.btnNext[this.step[val]]) {
        // 結束
        case 'result':
          this.funcStepThree();
          break;
      }
    },
    getBikeDataSuccess (val) {
      if (val) this.funcStepTwo();
    },
    getBikeDataFailed (val) {
      if (val) this.funcStepTwo();
    },
    bikeStatus (val) {
      // this.funcStepTwo()
      if (val === 1000 || val === 1001) this.funcStepTwo();
    }
  },
  computed: {
    loadImg () {
      switch (this.itemId) {
        case 'diagnosisSpeedSensor':
          return require('@/assets/images/diagnosis/img_sensor_speed.jpg');
        case 'diagnosisCadenceSensor':
          return require('@/assets/images/diagnosis/img_sensor_cadence.jpg');
        case 'diagnosisTorqueSensor':
          return require('@/assets/images/diagnosis/img_sensor_torque.jpg');
        default:
          return require('@/assets/images/diagnosis/no_image.jpg');
      }
    },
    step () {
      return Object.keys(this.btnNext);
    },
    stepName () {
      return this.btnNext[this.step[this.count]];
    },
    getBikeDataSuccess () {
      return this.bikeStatus === 1000 || this.bikeVal !== '';
    },
    getBikeDataFailed () {
      return this.bikeStatus === 1001 && this.bikeErrorCode.ErrorCode === 30031;
    }
  },
  methods: {
    funcStepOne () {
      this.isGreen = false;
      this.funcDiagnosisContent(
        this.content.step1,
        this.content.step2,
        this.content.step3
      );
    },
    funcStepTwo () {
      this.isGreen = false;
      this.isHidePower = true;
      this.time = true;

      this.funcDiagnosisContent(
        this.content.step2,
        this.content.step3,
        this.content.step4
      );
      // Success
      if (this.getBikeDataSuccess || this.bikeStatus === 1000) {
        this.time = false;
        this.funcDiagnosisContent(
          this.content.step2,
          `${this.bikeVal} ${this.content.step5}`,
          this.content.step8
        );
        setTimeout(() => {
          this.isHidePower = false;
          this.count++;
        }, 1000);
      } else if (this.getBikeDataFailed || this.bikeStatus === 1001) {
        // Failed
        this.time = false;
        this.funcDiagnosisContent(
          this.$t('diagnosis.diagnosisContent.timeUp'),
          this.$t('diagnosis.diagnosisContent.noSignal'),
          this.content.step8
        );
        setTimeout(() => {
          this.isHidePower = false;
          this.count++;
        }, 1000);
      } else this.isHidePower = true;
    },
    funcStepThree () {
      this.isGreen = false;
      this.isHide = true;
      this.time = false;
      this.btnCancel = '';

      if (this.bikeVal !== '') {
        this.isActive = false;
        this.isSuccess = true;
        this.description.status = this.content.step9;
        this.btnStep = this.content.step8;

        this.funcDiagnosisContent(
          `${this.bikeVal} ${this.content.step5}`,
          this.content.step8,
          ''
        );
        this.$store.dispatch('diagnosis/changeDiagnosisSensor', { title: this.title, id: this.itemId, result: true, errorCode: this.bikeErrorCode.ErrorCodeBike });
      } else {
        this.isActive = false;
        this.isSuccess = false;
        this.isError = true;
        this.description.status = this.content.step10;
        this.btnStep = this.content.step8;

        this.funcDiagnosisContent(
          this.content.step7,
          this.content.step8,
          ''
        );
        this.$store.dispatch('diagnosis/changeDiagnosisSensor', { title: this.title, id: this.itemId, result: false, errorCode: this.bikeErrorCode.ErrorCodeBike });
      }
    },
    funcStepDefault () {
      //  UI 显示
      this.isActive = true;
      this.isError = false;
      this.isSuccess = false;
      this.isHide = false;
      this.isHidePower = false;
      this.isGreen = true;
      this.time = false;
      //  UI 显示 end
      this.funcDiagnosisContent(
        '',
        this.content.step1,
        this.content.step2
      );
      this.description.status = '';
      this.second = 20;
      this.count = 0;
    },

    funcDiagnosisContent (c1, c2, c3) {
      this.description.desc1 = c1;
      this.description.desc2 = c2;
      this.description.desc3 = c3;
    },
    strSlice (str) {
      if (str !== undefined) {
        const index = str.indexOf(0);
        return str.slice(0, index);
      }
    },
    funcHandleDown (key) {
      this.second = 20;
      this.$emit('keyDownEvent', key);
    },
    funcHandlePower (power) {
      if (this.count < this.step.length - 1) {
        this.count++;
      }
      switch (this.stepName) {
        case 'next':
          this.funcStepOne();
          break;
        case 'countDown':
          this.funcStepTwo();
          break;
      }
      // bike console操作
      // 設定power鍵文字語系
      let btnName = [
        this.$t('diagnosis.btnStep.start'),
        this.$t('diagnosis.btnStep.next'),
        '',
        '',
        this.$t('diagnosis.btnStep.finish')
      ];
      this.$emit('keyPowerEvent', { name: this.diagnosisName, action: this.stepName });
      this.btnStep = btnName[this.count];
      // console.log('keyPowerEvent',this.btnStep )
      // console.log(this.$t('diagnosis.btnStep.next'))
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
